import { render, staticRenderFns } from "./PaginaInicialTable.vue?vue&type=template&id=164adb4d&scoped=true&lang=pug"
import script from "./PaginaInicialTable.vue?vue&type=script&lang=js"
export * from "./PaginaInicialTable.vue?vue&type=script&lang=js"
import style0 from "./PaginaInicialTable.vue?vue&type=style&index=0&id=164adb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164adb4d",
  null
  
)

export default component.exports